/**
 * 4.14b — the WhatsApp message a send left waiting for the sender, as the wa.me
 * link that opens it with the message already typed.
 *
 * On the link driver nothing leaves the server, so a WhatsApp send is finished
 * by the sender pressing send in their own WhatsApp. The compose screen opens it
 * once, straight after sending, and its result screen offers it again for when
 * that opening did not happen. Both ask here, so the button opens exactly what
 * the automatic opening would have.
 *
 * Null when there is nothing waiting: no WhatsApp among the channels, no number
 * to type a message out to, or a message the server sent itself — opening that
 * one again would have the sender send it twice.
 *
 * Its own module so it can be tested without a browser, as `composeWork.ts` is.
 */
export function whatsappHandOff(
  deliveries: ReadonlyArray<{ channel: 'email' | 'whatsapp'; delivered: boolean; deepLink?: string }>,
): string | null {
  return deliveries.find((one) => one.channel === 'whatsapp' && !one.delivered && one.deepLink)?.deepLink ?? null;
}
